<p-password [formControl]="control"
            placeholder="******"
            maxlength="6"
            [feedback]="false">


  <ng-template pTemplate="header">
    <h6 class="mb-2">Pick a pin</h6>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-divider></p-divider>
    <p class="text--sm mt-2">Requirements</p>
    <ul class="text--xs pl-2 ml-2 mt-1" style="list-style-type: disc;line-height: 1.5">
      <li>6 digits</li>
    </ul>
  </ng-template>
</p-password>
